import {
  stepAdGroupWizardConfig,
  stepCampaignSettingsWizardConfig,
  STEP_PATHS,
} from '@bingads-webui-campaign-react/xandr-campaign';

import { stepAdsWizardConfig } from './steps';

const ScenarioName = {
  XandrDisplayAdsCampaignCreation: 'XandrDisplayAdsCampaignCreation',
  XandrDisplayAdsAdGroupCreation: 'XandrDisplayAdsAdGroupCreation',
  XandrDisplayAdsCampaignSettings: 'XandrDisplayAdsCampaignSettings',
  XandrDisplayAdsAdGroupSettings: 'XandrDisplayAdsAdGroupSettings',
  XandrDisplayAdsCreation: 'XandrDisplayAdsCreation',
};

const STEP_INFOS = {
  [STEP_PATHS.CAMPAIGN_SETTINGS]: stepCampaignSettingsWizardConfig,
  [STEP_PATHS.AD_GROUP]: stepAdGroupWizardConfig,
  [STEP_PATHS.ADS]: stepAdsWizardConfig,
};

const applyCommonSettingsPageSettings = stepInfo => ({
  ...stepInfo,
  hideStepHeader: true,
});

// Scenarios
// I. Creation
//   1. Campaign creation
//   2. Ad group
// ...
// II. Settings
//   1. Campaign settings
//   2. Ad group settings

const XANDR_DISPLAY_ADS_CAMPAIGN_CREATION = {
  scenarioName: ScenarioName.XandrDisplayAdsCampaignCreation,
  isEditing: false,
  stepList: [
    STEP_INFOS[STEP_PATHS.CAMPAIGN_SETTINGS],
    STEP_INFOS[STEP_PATHS.AD_GROUP],
    STEP_INFOS[STEP_PATHS.ADS],
  ],
};

const XANDR_DISPLAY_ADS_AD_GROUP_CREATION = {
  scenarioName: ScenarioName.XandrDisplayAdsAdGroupCreation,
  isEditing: false,
  withContentFooter: false,
  stepList: [
    STEP_INFOS[STEP_PATHS.AD_GROUP],
    STEP_INFOS[STEP_PATHS.ADS],
  ],
};

const XANDR_DISPLAY_ADS_CAMPAIGN_SETTINGS = {
  scenarioName: ScenarioName.XandrDisplayAdsCampaignSettings,
  isEditing: true,
  stepList: [
    applyCommonSettingsPageSettings(STEP_INFOS[STEP_PATHS.CAMPAIGN_SETTINGS]),
  ],
};

const XANDR_DISPLAY_ADS_AD_GROUP_SETTINGS = {
  scenarioName: ScenarioName.XandrDisplayAdsAdGroupSettings,
  isEditing: true,
  stepList: [
    applyCommonSettingsPageSettings(STEP_INFOS[STEP_PATHS.AD_GROUP]),
  ],
};

export const XANDR_DISPLAY_ADS_CAMPAIGN_CRUD_SCENARIOS = {
  XANDR_DISPLAY_ADS_CAMPAIGN_CREATION,
  XANDR_DISPLAY_ADS_AD_GROUP_CREATION,
  XANDR_DISPLAY_ADS_CAMPAIGN_SETTINGS,
  XANDR_DISPLAY_ADS_AD_GROUP_SETTINGS,
};
